import React, { useContext } from 'react'
import { defaultState } from '../libs/fetchChannel'
import useChannel from '../libs/useChannel'
import { EnvVariablesContext } from '../contexts/EnvVariablesContext'

export const ChannelContext = React.createContext(defaultState)

const { Provider } = ChannelContext

const ChannelProvider = ({ value, children }) => {

  const { hostUrl  } = useContext(EnvVariablesContext)
  const { data } = useChannel(value ?? defaultState, hostUrl)

  return <Provider value={data}>{ children }</Provider>

}

export default ChannelProvider
